<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica pagina statica' : 'Nuovo pagina statica'"
                     @back="$router.replace('/cms')" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" >
          <h3>Info generali</h3>
        </v-col>
        <v-col cols="12" lg="6">
          <v-text-field
              label="Titolo*"
              v-model="editingItem.title.it"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6">
          <v-text-field
              label="Percorso*"
              v-model="editingItem.path"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="9" lg="5">
          <media-field label="Video" :aspect-ratio="16/9" media-type="video" v-model="editingItem.video_id"></media-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
              label="Contenuto*"
              v-model="editingItem.content.it"
              :rules="[rules.required]"
              counter
          ></v-textarea>
        </v-col>
        <v-col cols="6" md="4" lg="3" xl="2">
          <v-switch v-model="editingItem.pub" label="Pubblicata"></v-switch>
        </v-col>

        <form-footer @back="$router.replace('/cms')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type { CmsPage } from "@/models.ts";
import MediaField from "@/components/MediaField.vue";
export default {
  components: {MediaField, FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)

    const editingItem = ref<CmsPage>({
      content: {it:''}, path: "", pub: false, title: { it : ''}
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<CmsPage>('cms', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/cms')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      await Promise.all([
          globals.refreshEmpty('media')
      ])
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      form,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      rules,
      formatDate : utils.formatDate,
      async save(goBackAfterSave:boolean) {
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<CmsPage>('cms', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("pagina statica salvata")
        if(goBackAfterSave) {
          await router.replace('/cms')
        } else if(route.params.id === 'new'){
          await router.replace(`/cms/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
